import React, { useState } from 'react';
import {
  CustomLabel,
  CustomSwitch,
} from 'components/Common/MUIStyledComponents';
import { formatDate } from '../../../utils/dateFormater';
import DateSelector from 'components/Screening/filters/DateSelector';
import ModalLayout from 'components/DataFiltering/ModalLayout';
import { format } from 'date-fns';
import { Modal } from '@mui/material';
interface IModalCommon {
  handleOpen?: () => void;
  isOpenModal?: any;
  cur_case: any;
}

const EntitySettings: React.FC<IModalCommon> = ({ cur_case }) => {
  const [paramsModalOpen, setParamsModalOpen] = useState(false);
  const [appliedFilter] = useState<any>({});
  const [openDate, setOpenDate] = useState(false);
  const [submit, setSubmit] = useState<any>({
    trigger: false,
    reason: '',
    location: '',
  });

  const entityFilter = cur_case.data.entityFilter || {};
  const commodityFilter = cur_case.data.commodityFilter || {};

  const [entityState, setEntityState] = useState({
    lenses: entityFilter.lenses || [],
    countries: entityFilter.countries || [],
    agencies: entityFilter.agencies || [],
    lists: entityFilter.lists || [],
    fuzzy: entityFilter.entRes,
    dateRange: entityFilter.filterDate || [],
  });

  const [commodityState, setCommodityState] = useState({
    comLenses: commodityFilter.lenses || [],
    countries: commodityFilter.countries || [],
    agencies: commodityFilter.agencies || [],
    lists: commodityFilter.lists || [],
    fuzzy: commodityFilter.entRes,
    dateRange: commodityFilter.filterDate || [],
  });

  const handleDateChange = (newValue: any) => {
    const arr: any = [...newValue];
    if (newValue !== null) {
      arr.forEach((dt: any, index: number) => {
        if (dt !== null) {
          const dtWithoutTz = new Date(
            dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000,
          );
          const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
          arr[index] = formatted_dt;
        }
      });
    }
    setEntityState({ ...entityState, dateRange: arr });
    setCommodityState({ ...commodityState, dateRange: arr });
  };

  const handleClear = () => {
    setEntityState({
      lenses: entityFilter.lenses || [],
      countries: entityFilter.countries || [],
      agencies: entityFilter.agencies || [],
      lists: entityFilter.lists || [],
      fuzzy: entityFilter.entRes,
      dateRange: entityFilter.filterDate || [],
    });
    setCommodityState({
      comLenses: commodityFilter.lenses || [],
      countries: commodityFilter.countries || [],
      agencies: commodityFilter.agencies || [],
      lists: commodityFilter.lists || [],
      fuzzy: commodityFilter.entRes,
      dateRange: commodityFilter.filterDate || [],
    });
    setSubmit({
      reason: 'apply',
      trigger: !submit.trigger,
      location: 'Entity',
    });
  };

  return (
    <>
      <div className='setting-entity-cont'>
        <div className='setting-entity-cont-head'>
          <div className='setting-entity-cont-head-sec'>
            <div className='setting-entity-cont-head-sec-text'>
              Screening Parameters
            </div>
          </div>
        </div>
        <div className='setting-entity-cont-body'>
          <div className='setting-entity-cont-body-table'>
            <div className='setting-entity-cont-body-table-row'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <g clipPath='url(#clip0_26064_29775)'>
                  <path
                    d='M16.0616 11.5058C13.9443 13.0121 11.1671 13.1794 8.90777 12M1.93833 6.49417C4.06079 4.98425 6.84633 4.81978 9.10862 6.00862M11.5303 10.5933C13.6953 9.22876 14.9489 6.7306 14.7007 4.13417M6.43638 7.42778C4.29174 8.79682 3.05219 11.2827 3.29908 13.8658M11.6452 7.60278C11.5454 5.04638 10.0087 2.71263 7.63658 1.62917M6.35671 10.4442C6.47334 12.9822 8.00571 15.294 10.3633 16.3708M14.3033 3.6967C17.2322 6.62563 17.2322 11.3744 14.3033 14.3033C11.3744 17.2322 6.62562 17.2322 3.6967 14.3033C0.767767 11.3744 0.767767 6.62562 3.6967 3.6967C6.62563 0.767767 11.3744 0.767767 14.3033 3.6967ZM11.1213 6.87868C12.2929 8.05025 12.2929 9.94975 11.1213 11.1213C9.94975 12.2929 8.05025 12.2929 6.87868 11.1213C5.70711 9.94975 5.70711 8.05025 6.87868 6.87868C8.05025 5.70711 9.94975 5.70711 11.1213 6.87868Z'
                    stroke='var(--card-text)'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_26064_29775'>
                    <rect width='18' height='18' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              <div className='setting-entity-cont-body-table-row-text'>
                Lens
              </div>
              <div className='setting-entity-cont-body-table-row-card'>
                <div className='setting-entity-cont-body-table-row-card-text'>
                  {entityState.lenses.length + commodityState.comLenses.length}
                </div>
              </div>
            </div>
            <div className='setting-entity-cont-body-table-row'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <g clipPath='url(#clip0_26064_29781)'>
                  <path
                    d='M2.30699 5.61212L5.52302 7.90924C5.69036 8.02877 5.77404 8.08854 5.86161 8.10231C5.93866 8.11442 6.01758 8.10221 6.08736 8.06737C6.16668 8.02778 6.22837 7.94552 6.35176 7.781L7.03134 6.87489C7.06623 6.82836 7.08367 6.8051 7.10418 6.78503C7.12239 6.76722 7.14236 6.7513 7.1638 6.73753C7.18794 6.72203 7.21451 6.71022 7.26765 6.6866L10.1691 5.39707C10.2894 5.34361 10.3495 5.31688 10.3949 5.27514C10.435 5.23822 10.4665 5.193 10.4874 5.14263C10.511 5.08568 10.5153 5.02002 10.5241 4.88869L10.7365 1.70205M10.125 10.125L12.087 10.9659C12.3146 11.0634 12.4285 11.1122 12.4888 11.1932C12.5417 11.2643 12.5677 11.3518 12.5622 11.4403C12.556 11.5411 12.4873 11.6441 12.3499 11.8502L11.4281 13.2328C11.363 13.3305 11.3304 13.3794 11.2874 13.4147C11.2493 13.446 11.2054 13.4695 11.1583 13.4838C11.105 13.5 11.0463 13.5 10.9289 13.5H9.43246C9.27695 13.5 9.19919 13.5 9.13303 13.474C9.07461 13.451 9.02289 13.4137 8.98262 13.3656C8.93701 13.311 8.91242 13.2373 8.86325 13.0897L8.32859 11.4858C8.29959 11.3988 8.28508 11.3553 8.28127 11.311C8.27788 11.2718 8.28069 11.2323 8.28958 11.194C8.29962 11.1508 8.32013 11.1097 8.36115 11.0277L8.76728 10.2154C8.8498 10.0504 8.89106 9.96789 8.95461 9.91666C9.01061 9.87151 9.07842 9.84342 9.14994 9.83575C9.23111 9.82704 9.31863 9.85621 9.49367 9.91456L10.125 10.125ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z'
                    stroke='var(--card-text)'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_26064_29781'>
                    <rect width='18' height='18' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              <div className='setting-entity-cont-body-table-row-text'>
                Listing Country
              </div>
              <div className='setting-entity-cont-body-table-row-card'>
                <div className='setting-entity-cont-body-table-row-card-text'>
                  {entityState.countries.length +
                    commodityState.countries.length}
                </div>
              </div>
            </div>
            <div className='setting-entity-cont-body-table-row'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <path
                  d='M3.75 6.75026V12.7503M7.125 6.75026V12.7503M10.875 6.75026V12.7503M14.25 6.75026V12.7503M2.25 13.9503L2.25 14.5503C2.25 14.9703 2.25 15.1803 2.33175 15.3408C2.40365 15.4819 2.51839 15.5966 2.65951 15.6685C2.81994 15.7503 3.02996 15.7503 3.45 15.7503H14.55C14.97 15.7503 15.1801 15.7503 15.3405 15.6685C15.4816 15.5966 15.5963 15.4819 15.6683 15.3408C15.75 15.1803 15.75 14.9703 15.75 14.5503V13.9503C15.75 13.5302 15.75 13.3202 15.6683 13.1598C15.5963 13.0186 15.4816 12.9039 15.3405 12.832C15.1801 12.7503 14.97 12.7503 14.55 12.7503H3.45C3.02996 12.7503 2.81994 12.7503 2.65951 12.832C2.51839 12.9039 2.40365 13.0186 2.33175 13.1598C2.25 13.3202 2.25 13.5302 2.25 13.9503ZM8.73968 2.30811L3.18968 3.54144C2.85439 3.61595 2.68674 3.65321 2.5616 3.74336C2.45122 3.82288 2.36455 3.93093 2.31086 4.05593C2.25 4.19765 2.25 4.36939 2.25 4.71286L2.25 5.55026C2.25 5.9703 2.25 6.18032 2.33175 6.34075C2.40365 6.48187 2.51839 6.59661 2.65951 6.66851C2.81994 6.75026 3.02996 6.75026 3.45 6.75026H14.55C14.97 6.75026 15.1801 6.75026 15.3405 6.66851C15.4816 6.59661 15.5963 6.48187 15.6683 6.34075C15.75 6.18032 15.75 5.9703 15.75 5.55026V4.71287C15.75 4.36939 15.75 4.19765 15.6891 4.05593C15.6355 3.93093 15.5488 3.82288 15.4384 3.74336C15.3133 3.65321 15.1456 3.61595 14.8103 3.54144L9.26032 2.30811C9.16317 2.28652 9.1146 2.27573 9.06552 2.27142C9.02192 2.2676 8.97808 2.2676 8.93448 2.27142C8.8854 2.27573 8.83683 2.28652 8.73968 2.30811Z'
                  stroke='var(--card-text)'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              <div className='setting-entity-cont-body-table-row-text'>
                Agency
              </div>
              <div className='setting-entity-cont-body-table-row-card'>
                <div className='setting-entity-cont-body-table-row-card-text'>
                  {entityState.agencies.length + commodityState.agencies.length}
                </div>
              </div>
            </div>
            <div className='setting-entity-cont-body-table-row'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <path
                  d='M15.75 9L6.75 9M15.75 4.5L6.75 4.5M15.75 13.5L6.75 13.5M3.75 9C3.75 9.41421 3.41421 9.75 3 9.75C2.58579 9.75 2.25 9.41421 2.25 9C2.25 8.58579 2.58579 8.25 3 8.25C3.41421 8.25 3.75 8.58579 3.75 9ZM3.75 4.5C3.75 4.91421 3.41421 5.25 3 5.25C2.58579 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75C3.41421 3.75 3.75 4.08579 3.75 4.5ZM3.75 13.5C3.75 13.9142 3.41421 14.25 3 14.25C2.58579 14.25 2.25 13.9142 2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75C3.41421 12.75 3.75 13.0858 3.75 13.5Z'
                  stroke='var(--card-text)'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              <div className='setting-entity-cont-body-table-row-text'>
                Source List
              </div>
              <div className='setting-entity-cont-body-table-row-card'>
                <div className='setting-entity-cont-body-table-row-card-text'>
                  {entityState.lists.length + commodityState.lists.length}
                </div>
              </div>
            </div>
            <div className='setting-entity-cont-body-table-row'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <path
                  d='M15.75 7.5H2.25M12 1.5V4.5M6 1.5V4.5M5.85 16.5H12.15C13.4101 16.5 14.0402 16.5 14.5215 16.2548C14.9448 16.039 15.289 15.6948 15.5048 15.2715C15.75 14.7902 15.75 14.1601 15.75 12.9V6.6C15.75 5.33988 15.75 4.70982 15.5048 4.22852C15.289 3.80516 14.9448 3.46095 14.5215 3.24524C14.0402 3 13.4101 3 12.15 3H5.85C4.58988 3 3.95982 3 3.47852 3.24524C3.05516 3.46095 2.71095 3.80516 2.49524 4.22852C2.25 4.70982 2.25 5.33988 2.25 6.6V12.9C2.25 14.1601 2.25 14.7902 2.49524 15.2715C2.71095 15.6948 3.05516 16.039 3.47852 16.2548C3.95982 16.5 4.58988 16.5 5.85 16.5Z'
                  stroke='var(--card-text)'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              <div className='setting-entity-cont-body-table-row-text'>
                Date
              </div>
              <div className='setting-entity-cont-body-table-row-plain-text'>
                {entityState.dateRange.length > 0 &&
                entityState.dateRange[0] !== null &&
                entityState.dateRange[1] !== null
                  ? `${formatDate(entityState.dateRange[0])} - ${formatDate(
                      entityState.dateRange[1],
                    )}`
                  : 'None Selected'}
              </div>
            </div>
            <div className='setting-entity-cont-body-table-row'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <g clipPath='url(#clip0_26064_29797)'>
                  <path
                    d='M6.75 9L8.25 10.5L11.625 7.125M13.4259 3.74888C13.5803 4.1224 13.8768 4.4193 14.25 4.5743L15.5589 5.11648C15.9325 5.27121 16.2292 5.568 16.384 5.94154C16.5387 6.31509 16.5387 6.73481 16.384 7.10836L15.8422 8.41635C15.6874 8.79007 15.6872 9.21021 15.8427 9.58374L16.3835 10.8913C16.4602 11.0764 16.4997 11.2747 16.4997 11.475C16.4998 11.6752 16.4603 11.8736 16.3837 12.0586C16.3071 12.2436 16.1947 12.4118 16.0531 12.5534C15.9114 12.695 15.7433 12.8073 15.5582 12.8839L14.2503 13.4256C13.8768 13.5801 13.5799 13.8765 13.4249 14.2498L12.8827 15.5588C12.728 15.9323 12.4312 16.2291 12.0577 16.3838C11.6841 16.5386 11.2644 16.5386 10.8909 16.3838L9.58296 15.842C9.20942 15.6877 8.78987 15.688 8.41656 15.8429L7.10767 16.3843C6.73434 16.5387 6.31501 16.5386 5.94178 16.384C5.56855 16.2293 5.27194 15.9329 5.11711 15.5598L4.57479 14.2504C4.42035 13.8769 4.12391 13.58 3.75064 13.425L2.44175 12.8828C2.06838 12.7282 1.77169 12.4316 1.61691 12.0582C1.46213 11.6849 1.46192 11.2654 1.61633 10.8919L2.1581 9.58391C2.31244 9.21035 2.31213 8.79079 2.15722 8.41746L1.61623 7.10759C1.53953 6.92257 1.50003 6.72426 1.5 6.52397C1.49997 6.32369 1.5394 6.12536 1.61604 5.94032C1.69268 5.75529 1.80504 5.58716 1.94668 5.44556C2.08832 5.30396 2.25647 5.19166 2.44152 5.11508L3.74947 4.57329C4.12265 4.41898 4.41936 4.1229 4.57448 3.75004L5.11664 2.44111C5.27136 2.06756 5.56813 1.77078 5.94167 1.61605C6.3152 1.46132 6.7349 1.46132 7.10844 1.61605L8.41638 2.15784C8.78993 2.31218 9.20948 2.31187 9.58279 2.15696L10.8922 1.61689C11.2657 1.46224 11.6853 1.46228 12.0588 1.61697C12.4322 1.77167 12.729 2.06837 12.8837 2.44182L13.426 3.75115L13.4259 3.74888Z'
                    stroke='var(--card-text)'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_26064_29797'>
                    <rect width='18' height='18' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              <div className='setting-entity-cont-body-table-row-text'>
                Entity Resolution
              </div>
              <CustomLabel
                control={
                  <CustomSwitch checked={entityState.fuzzy} name='ticket' />
                }
                label={entityState.fuzzy ? 'Yes' : 'No'}
              />
            </div>
            <div
              className='setting-entity-cont-body-table-row'
              style={{ cursor: 'pointer' }}
              onClick={() => setParamsModalOpen(true)}
            >
              <div className='setting-entity-cont-body-table-row-edit'>
                Edit
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal open={paramsModalOpen} onClose={() => setParamsModalOpen(false)}>
        <ModalLayout
          setFilterMode={setParamsModalOpen}
          submit={submit}
          setSubmit={setSubmit}
          entityState={entityState}
          setEntityState={setEntityState}
          commodityState={commodityState}
          setCommodityState={setCommodityState}
          appliedFilter={appliedFilter}
          handleClear={handleClear}
          setOpenDate={setOpenDate}
          result={true}
        />
      </Modal>
      <Modal open={openDate} onClose={() => setOpenDate(false)}>
        <DateSelector
          openDate={openDate}
          setOpenDate={setOpenDate}
          state={entityState}
          handleDateChange={handleDateChange}
          setSubmit={setSubmit}
          submit={submit}
        />
      </Modal>
    </>
  );
};

export default EntitySettings;
